export default __webpack_public_path__ + "static/media/ic-img.daecade4.svg";